import React, { FC, HTMLAttributes } from 'react';
import ContactsSection from './ContactsSection';
import useSite from 'src/hooks/api/useSite';
import Contact, { CreateContactOptions } from 'src/interfaces/api/Contact';
import useContacts from 'src/scenes/components/display/hooks/useContacts';

interface Props extends HTMLAttributes<HTMLDivElement> {
  siteId?: string;
  contacts: [];
  loading: boolean;
  hidden: boolean;
}

const ContactsSectionContainer: FC<Props> = ({ loading, contacts, siteId, ...props }) => {
  const { siteContacts: contactsV2, create, loading: contactsLoading } = useContacts();
  const { addContact, revokeAccess } = useSite();

  const handleCreateContact = async (contactOptions: CreateContactOptions) => {
    try {
      await create(contactOptions);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const handleAddContact = async (siteId: string, contact: Contact) => {
    try {
      await addContact(siteId, contact.id);
      location.reload();
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const handleRevokeCustomerAccess = async (customerAccessId: string) => {
    try {
      if (siteId) {
        await revokeAccess(siteId, customerAccessId);
        location.reload();
      } else {
        throw new Error('Aucun identifiant de site trouvé');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  };

  return (
    <ContactsSection
      siteId={siteId}
      contacts={contacts}
      contactsV2={contactsV2}
      onMigrateContact={handleCreateContact}
      onAddContact={handleAddContact}
      onRevokeCustomerAccess={handleRevokeCustomerAccess}
      loading={loading || contactsLoading}
      {...props}
    />
  );
};

export default ContactsSectionContainer;
